import React from 'react'

export interface FixedBottomProps {
    children: React.ReactNode
    className?: string
}

/**
 * 固定底部按钮容器组件
 * 用于在页面底部固定显示按钮
 */
const FixedBottom: React.FC<FixedBottomProps> = ({
    children,
    className = ''
}) => {
    return (
        <div className={`fixed bottom-0 left-0 right-0 z-11 px-5 py-4 max-w-[750px] mx-auto ${className}`}>
            {children}
        </div>
    )
}

export default FixedBottom

